import { DEPLOYMENT_ENVIRONMENT, DeploymentEnvironment } from 'env/environments';
import { ZHLDomain } from 'src/common/constants';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';

/**
 * Gets the ZHL origin for the deployment environment, preferring the environment passed in
 * but defaulting to the next/config defined deployment environment when not passed an argument
 */
export const getIntegrationZHLOriginForDeploymentEnvironment = (env?: DeploymentEnvironment): string => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const { ENV } = publicRuntimeConfig;
    const environmentToUse = env ?? ENV;
    switch (environmentToUse) {
        case DEPLOYMENT_ENVIRONMENT.PRODUCTION:
            return ZHLDomain.PROD;
        case DEPLOYMENT_ENVIRONMENT.LOCAL:
        case DEPLOYMENT_ENVIRONMENT.STAGING:
            return ZHLDomain.STAGING;
        case DEPLOYMENT_ENVIRONMENT.DEVELOPMENT:
            return ZHLDomain.DEVELOPMENT;
    }
};
